// // import React from "react";
// // import styled, { keyframes } from "styled-components";
// // import { Fade } from "react-awesome-reveal";
// // import { Zap, ArrowRight, CheckCircle2, Sparkles } from "lucide-react";

// // // High-attention flashing and pulsing effects in striking blue/cyan
// // const flashAttention = keyframes`
// //   0%, 100% {
// //     transform: scale(1);
// //     box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.7);
// //   }
// //   50% {
// //     transform: scale(1.03);
// //     box-shadow: 0 0 0 10px rgba(37, 99, 235, 0);
// //   }
// // `;

// // const textGlow = keyframes`
// //   0%, 100% { opacity: 1; }
// //   50% { opacity: 0.5; }
// // `;

// // const PromoSection = styled.section`
// //   padding: 10px;
// //   background-color: #ffffff;
// //   position: relative;
// //   overflow: hidden;
// // `;

// // const Container = styled.div`
// //   max-width: 1200px;
// //   margin: 0 auto;
// // `;

// // const PromoCard = styled.div`
// //   position: relative;
// //   border-radius: 10px;
// //   overflow: hidden;
// //   border: 2px solid #2563eb;
// //   box-shadow: 0 6px 15px rgba(37, 99, 235, 0.2);
// //   background: linear-gradient(
// //       rgba(239, 246, 255, 0.95), 
// //       rgba(219, 234, 254, 0.98)
// //     ),
// //     url("https://images.unsplash.com/photo-1590381105924-c72589b9ef3f?auto=format&fit=crop&w=1920&q=80") 
// //     no-repeat center center/cover;
// //   padding: 10px;
// //   display: flex;
// //   flex-direction: column;
// //   align-items: center;
// //   text-align: center;
// //   gap: 10px;
// // `;

// // const AlertBadge = styled.div`
// //   display: inline-flex;
// //   align-items: center;
// //   gap: 6px;
// //   background-color: #2563eb;
// //   color: #ffffff;
// //   padding: 4px 10px;
// //   font-size: 0.8rem;
// //   font-weight: 900;
// //   text-transform: uppercase;
// //   letter-spacing: 1.5px;
// //   border-radius: 50px;
// //   animation: ${flashAttention} 1.5s infinite;

// //   span {
// //     animation: ${textGlow} 1s infinite;
// //   }
// // `;

// // const PromoTitle = styled.h2`
// //   font-size: clamp(1.6rem, 3.5vw, 2.4rem);
// //   font-weight: 900;
// //   color: #0a192f;
// //   line-height: 1.2;
// //   margin: 0;

// //   span {
// //     color: #2563eb;
// //     text-decoration: underline;
// //   }
// // `;

// // const PromoDescription = styled.p`
// //   font-size: 0.95rem;
// //   color: #1e293b;
// //   font-weight: 600;
// //   max-width: 700px;
// //   line-height: 1.5;
// //   margin: 0;
// // `;

// // const HighlightFeatures = styled.div`
// //   display: flex;
// //   flex-wrap: wrap;
// //   justify-content: center;
// //   gap: 8px;
// //   margin-top: 4px;

// //   div {
// //     display: flex;
// //     align-items: center;
// //     gap: 4px;
// //     color: #1e40af;
// //     font-weight: 700;
// //     font-size: 0.85rem;
// //     background: #dbeafe;
// //     padding: 4px 8px;
// //     border-radius: 6px;
// //     border: 1px solid #93c5fd;

// //     svg {
// //       color: #2563eb;
// //     }
// //   }
// // `;

// // const ActionButton = styled.a`
// //   display: inline-flex;
// //   align-items: center;
// //   gap: 6px;
// //   background-color: #2563eb;
// //   color: #ffffff;
// //   padding: 8px 10px;
// //   font-size: 1rem;
// //   font-weight: 800;
// //   border-radius: 50px;
// //   text-decoration: none;
// //   transition: all 0.3s ease;
// //   box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
// //   margin-top: 4px;

// //   &:hover {
// //     background-color: #0a192f;
// //     color: #ffffff;
// //     transform: translateY(-2px);
    
// //     svg {
// //       transform: translateX(4px);
// //     }
// //   }

// //   svg {
// //     transition: transform 0.3s ease;
// //   }
// // `;

// // const InnovationCityBanner = () => {
// //   return (
// //     <PromoSection>
// //       <Container>
// //         <Fade direction="up" triggerOnce>
// //           <PromoCard>
// //             <AlertBadge>
// //               <Sparkles size={16} />
// //               <span>Selling Now • Urgent Call</span>
// //             </AlertBadge>

// //             <PromoTitle>
// //               Innovation City <span>Apo, Abuja</span>
// //             </PromoTitle>

// //             <PromoDescription>
// //               Don't miss out! Secure prime land banking and property investments right now. Click below to instantly view plot sizes, pricing, and immediate availability.
// //             </PromoDescription>

// //             <HighlightFeatures>
// //               <div><CheckCircle2 size={14} /> Prime Location</div>
// //               <div><CheckCircle2 size={14} /> Fast Allocation</div>
// //               <div><CheckCircle2 size={14} /> High ROI</div>
// //             </HighlightFeatures>

// //             <ActionButton href="/innovationcitydetails">
// //               Click Here to View Plots & Prices <ArrowRight size={16} />
// //             </ActionButton>
// //           </PromoCard>
// //         </Fade>
// //       </Container>
// //     </PromoSection>
// //   );
// // };

// // export default InnovationCityBanner;





// import React, { useState, useEffect } from "react";
// import styled, { keyframes } from "styled-components";
// import { Fade } from "react-awesome-reveal";
// import { Zap, ArrowRight, CheckCircle2, Sparkles, ChevronLeft, ChevronRight } from "lucide-react";

// // High-attention flashing and pulsing effects in striking blue/cyan
// const flashAttention = keyframes`
//   0%, 100% {
//     transform: scale(1);
//     box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.7);
//   }
//   50% {
//     transform: scale(1.03);
//     box-shadow: 0 0 0 10px rgba(37, 99, 235, 0);
//   }
// `;

// const textGlow = keyframes`
//   0%, 100% { opacity: 1; }
//   50% { opacity: 0.5; }
// `;

// const PromoSection = styled.section`
//   padding: 20px 10px;
//   background-color: #ffffff;
//   position: relative;
//   overflow: hidden;
// `;

// const Container = styled.div`
//   max-width: 1200px;
//   margin: 0 auto;
//   position: relative;
// `;

// const PromoCard = styled.div`
//   position: relative;
//   border-radius: 12px;
//   overflow: hidden;
//   border: 2px solid #2563eb;
//   box-shadow: 0 8px 25px rgba(37, 99, 235, 0.25);
//   background: linear-gradient(
//       rgba(239, 246, 255, 0.95), 
//       rgba(219, 234, 254, 0.98)
//     ),
//     url(${({ $bgImage }) => $bgImage}) no-repeat center center/cover;
//   padding: 24px 16px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   text-align: center;
//   gap: 14px;
//   transition: background 0.5s ease-in-out;
// `;

// // Round image container for the property preview
// const RoundImageContainer = styled.div`
//   width: 100px;
//   height: 100px;
//   border-radius: 50%;
//   overflow: hidden;
//   border: 3px solid #2563eb;
//   box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
//   margin-bottom: 4px;
//   background-color: #ffffff;

//   img {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//     transition: transform 0.4s ease;

//     &:hover {
//       transform: scale(1.1);
//     }
//   }
// `;

// const AlertBadge = styled.div`
//   display: inline-flex;
//   align-items: center;
//   gap: 6px;
//   background-color: #2563eb;
//   color: #ffffff;
//   padding: 4px 12px;
//   font-size: 0.8rem;
//   font-weight: 900;
//   text-transform: uppercase;
//   letter-spacing: 1.5px;
//   border-radius: 50px;
//   animation: ${flashAttention} 1.5s infinite;

//   span {
//     animation: ${textGlow} 1s infinite;
//   }
// `;

// const PromoTitle = styled.h2`
//   font-size: clamp(1.6rem, 3.5vw, 2.4rem);
//   font-weight: 900;
//   color: #0a192f;
//   line-height: 1.2;
//   margin: 0;

//   span {
//     color: #2563eb;
//     text-decoration: underline;
//   }
// `;

// const PromoDescription = styled.p`
//   font-size: 0.95rem;
//   color: #1e293b;
//   font-weight: 600;
//   max-width: 700px;
//   line-height: 1.5;
//   margin: 0;
// `;

// const HighlightFeatures = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: center;
//   gap: 8px;
//   margin-top: 4px;

//   div {
//     display: flex;
//     align-items: center;
//     gap: 4px;
//     color: #1e40af;
//     font-weight: 700;
//     font-size: 0.85rem;
//     background: #dbeafe;
//     padding: 4px 10px;
//     border-radius: 6px;
//     border: 1px solid #93c5fd;

//     svg {
//       color: #2563eb;
//     }
//   }
// `;

// const ActionButton = styled.a`
//   display: inline-flex;
//   align-items: center;
//   gap: 6px;
//   background-color: #2563eb;
//   color: #ffffff;
//   padding: 10px 18px;
//   font-size: 1rem;
//   font-weight: 800;
//   border-radius: 50px;
//   text-decoration: none;
//   transition: all 0.3s ease;
//   box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
//   margin-top: 6px;

//   &:hover {
//     background-color: #0a192f;
//     color: #ffffff;
//     transform: translateY(-2px);
    
//     svg {
//       transform: translateX(4px);
//     }
//   }

//   svg {
//     transition: transform 0.3s ease;
//   }
// `;

// // Slider Navigation Controls
// const NavButtonsContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   gap: 12px;
//   margin-top: 14px;
// `;

// const ControlButton = styled.button`
//   background-color: #2563eb;
//   color: #ffffff;
//   border: none;
//   width: 38px;
//   height: 38px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   cursor: pointer;
//   box-shadow: 0 4px 10px rgba(37, 99, 235, 0.3);
//   transition: background-color 0.2s, transform 0.2s;

//   &:hover {
//     background-color: #0a192f;
//     transform: scale(1.08);
//   }
// `;

// const IndicatorsContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   gap: 6px;
//   margin-top: 10px;
// `;

// const Dot = styled.span`
//   width: ${({ $active }) => ($active ? "24px" : "8px")};
//   height: 8px;
//   border-radius: 4px;
//   background-color: ${({ $active }) => ($active ? "#2563eb" : "#cbd5e1")};
//   transition: all 0.3s ease;
//   cursor: pointer;
// `;

// // List of 3 Properties Selling Now
// const propertiesData = [
//   {
//     id: 1,
//     title: "Innovation City",
//     location: "Apo, Abuja",
//     description: "Don't miss out! Secure prime land banking and property investments right now. Click below to instantly view plot sizes, pricing, and immediate availability.",
//     image: "https://images.unsplash.com/photo-1590381105924-c72589b9ef3f?auto=format&fit=crop&w=600&q=80",
//     bgImage: "https://images.unsplash.com/photo-1590381105924-c72589b9ef3f?auto=format&fit=crop&w=1920&q=80",
//     features: ["Prime Location", "Fast Allocation", "High ROI"],
//     link: "/innovationcitydetails",
//     buttonText: "View Innovation City Plots & Prices"
//   },
//   {
//     id: 2,
//     title: "Emerald Heights",
//     location: "Maitama Extension, Abuja",
//     description: "Experience luxury living at its finest. Premium fully-serviced residential plots and smart apartments ready for immediate development with flexible payment plans.",
//     image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=600&q=80",
//     bgImage: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=1920&q=80",
//     features: ["Smart Estate", "24/7 Security", "Flexible Plan"],
//     link: "/ligabsestateidudetails",
//     buttonText: "View Emerald Heights Units"
//   },
//   {
//     id: 3,
//     title: "Royal Palm Gardens",
//     location: "Lekki Phase 1, Lagos",
//     description: "High-yield commercial and residential waterfront plots. Exceptional capital appreciation guaranteed within a rapidly expanding economic hub.",
//     image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=600&q=80",
//     bgImage: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1920&q=80",
//     features: ["Waterfront View", "Instant Title", "High Commercial Value"],
//     link: "/royalpalmdetails",
//     buttonText: "Explore Royal Palm Properties"
//   }
// ];

// const InnovationCityBanner = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   // Automatic slide rotation every 5 seconds
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % propertiesData.length);
//     }, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   const handlePrev = () => {
//     setCurrentIndex((prevIndex) => (prevIndex === 0 ? propertiesData.length - 1 : prevIndex - 1));
//   };

//   const handleNext = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % propertiesData.length);
//   };

//   const currentProperty = propertiesData[currentIndex];

//   return (
//     <PromoSection>
//       <Container>
//         <Fade key={currentIndex} direction="right" triggerOnce>
//           <PromoCard $bgImage={currentProperty.bgImage}>
//             {/* Round Container for Property Image */}
//             <RoundImageContainer>
//               <img src={currentProperty.image} alt={currentProperty.title} />
//             </RoundImageContainer>

//             <AlertBadge>
//               <Sparkles size={16} />
//               <span>Selling Now • Urgent Call</span>
//             </AlertBadge>

//             <PromoTitle>
//               {currentProperty.title} <span>{currentProperty.location}</span>
//             </PromoTitle>

//             <PromoDescription>
//               {currentProperty.description}
//             </PromoDescription>

//             <HighlightFeatures>
//               {currentProperty.features.map((feature, idx) => (
//                 <div key={idx}>
//                   <CheckCircle2 size={14} /> {feature}
//                 </div>
//               ))}
//             </HighlightFeatures>

//             <ActionButton href={currentProperty.link}>
//               {currentProperty.buttonText} <ArrowRight size={16} />
//             </ActionButton>
//           </PromoCard>
//         </Fade>

//         {/* Slider Navigation Buttons and Indicators */}
//         <NavButtonsContainer>
//           <ControlButton onClick={handlePrev} aria-label="Previous Property">
//             <ChevronLeft size={20} />
//           </ControlButton>
//           <ControlButton onClick={handleNext} aria-label="Next Property">
//             <ChevronRight size={20} />
//           </ControlButton>
//         </NavButtonsContainer>

//         <IndicatorsContainer>
//           {propertiesData.map((_, index) => (
//             <Dot
//               key={index}
//               $active={currentIndex === index}
//               onClick={() => setCurrentIndex(index)}
//             />
//           ))}
//         </IndicatorsContainer>
//       </Container>
//     </PromoSection>
//   );
// };

// export default InnovationCityBanner;
import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { Fade } from "react-awesome-reveal";
import { Zap, ArrowRight, CheckCircle2, Sparkles, ChevronLeft, ChevronRight } from "lucide-react";
import apoimg from '../images/apoimg.jpg'
import iduimg from '../images/iduimg.jpg'
import p1 from '../images/p1.jpeg'
import fl2 from '../images/fl2.jpg'


// High-attention flashing and pulsing effects in striking blue/cyan
const flashAttention = keyframes`
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.7);
  }
  50% {
    transform: scale(1.03);
    box-shadow: 0 0 0 10px rgba(37, 99, 235, 0);
  }
`;

const textGlow = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

const PromoSection = styled.section`
  padding: 20px 10px;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
`;

const PromoCard = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid #2563eb;
  box-shadow: 0 8px 25px rgba(37, 99, 235, 0.25);
  background: linear-gradient(
      rgba(239, 246, 255, 0.95), 
      rgba(219, 234, 254, 0.98)
    ),
    url(${({ $bgImage }) => $bgImage}) no-repeat center center/cover;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;
  transition: background 0.5s ease-in-out;
`;

// Round image container for the property preview
const RoundImageContainer = styled.div`
  width: 200px;
  // height: 150px;
  border-radius:20px;
  overflow: hidden;
  border: 3px solid #2563eb;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
  margin-bottom: 4px;
  background-color: #ffffff;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;

    &:hover {
      transform: scale(1.1);
    }
  }
`;

const AlertBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #2563eb;
  color: #ffffff;
  padding: 4px 12px;
  font-size: 0.8rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  border-radius: 50px;
  animation: ${flashAttention} 1.5s infinite;

  span {
    animation: ${textGlow} 1s infinite;
  }
`;

const PromoTitle = styled.h2`
  font-size: clamp(1.6rem, 3.5vw, 2.4rem);
  font-weight: 900;
  color: #0a192f;
  line-height: 1.2;
  margin: 0;

  span {
    color: #2563eb;
    text-decoration: underline;
  }
`;

const PromoDescription = styled.p`
  font-size: 0.95rem;
  color: #1e293b;
  font-weight: 600;
  max-width: 700px;
  line-height: 1.5;
  margin: 0;
`;

const HighlightFeatures = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 4px;

  div {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #1e40af;
    font-weight: 700;
    font-size: 0.85rem;
    background: #dbeafe;
    padding: 4px 10px;
    border-radius: 6px;
    border: 1px solid #93c5fd;

    svg {
      color: #2563eb;
    }
  }
`;

const ActionButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #2563eb;
  color: #ffffff;
  padding: 10px 18px;
  font-size: 1rem;
  font-weight: 800;
  border-radius: 50px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
  margin-top: 6px;

  &:hover {
    background-color: #0a192f;
    color: #ffffff;
    transform: translateY(-2px);
    
    svg {
      transform: translateX(4px);
    }
  }

  svg {
    transition: transform 0.3s ease;
  }
`;

// Slider Navigation Controls
const NavButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 14px;
`;

const ControlButton = styled.button`
  background-color: #2563eb;
  color: #ffffff;
  border: none;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.3);
  transition: background-color 0.2s, transform 0.2s;

  &:hover {
    background-color: #0a192f;
    transform: scale(1.08);
  }
`;

const IndicatorsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 10px;
`;

const Dot = styled.span`
  width: ${({ $active }) => ($active ? "24px" : "8px")};
  height: 8px;
  border-radius: 4px;
  background-color: ${({ $active }) => ($active ? "#2563eb" : "#cbd5e1")};
  transition: all 0.3s ease;
  cursor: pointer;
`;

// List of 3 Properties Selling Now (Updated Property #2 to Ligabs Estate Idu)
const propertiesData = [
  {
    id: 1,
    title: "Innovation City",
    location: "Apo, Abuja",
    // description: "Don't miss out! Secure prime land banking and property investments right now. Click below to instantly view plot sizes, pricing, and immediate availability.",
    image: fl2,
    bgImage: "https://images.unsplash.com/photo-1590381105924-c72589b9ef3f?auto=format&fit=crop&w=1920&q=80",
    features: ["Prime Location", "Fast Allocation", "High ROI"],
    link: "/innovationcitydetails",
    buttonText: "View Innovation City Plots & Prices"
  },
  {
    id: 2,
    title: "Ligabs Estate",
    location: "Idu, Abuja",
    // description: "Experience luxury living at its finest. Premium 4-bedroom terraces, semi-detached, and fully-detached units with BQ ready for immediate development with flexible payment plans.",
    image: fl2,
    bgImage: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=1920&q=80",
    features: ["4 Bedroom Units", "Fully Serviced BQ", "Flexible Payment Plan"],
    link: "/ligabsestateidudetails",
    buttonText: "View Ligabs Estate Idu Units"
  },
  // {
  //   id: 3,
  //   title: "Access Gate",
  //   location: "Properties",
  //   // description: "High-yield commercial and residential waterfront plots. Exceptional capital appreciation guaranteed within a rapidly expanding economic hub.",
  //   image:fl2,
  //   bgImage: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1920&q=80",
  //   features: ["Waterfront View", "Instant Title", "High Commercial Value"],
  //   link: "/accessgatedetails",
  //   buttonText: "Explore Royal Palm Properties"
  // }
];

const PropertyCarouselBanner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Automatic slide rotation every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % propertiesData.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? propertiesData.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % propertiesData.length);
  };

  const currentProperty = propertiesData[currentIndex];

  return (
    <PromoSection>
      <Container>
        <Fade key={currentIndex} direction="right" triggerOnce>
          <PromoCard $bgImage={currentProperty.bgImage}>
            {/* Round Container for Property Image */}
            <RoundImageContainer>
              <img src={currentProperty.image} alt={currentProperty.title} />
            </RoundImageContainer>

            <AlertBadge>
              <Sparkles size={16} />
              <span>Selling Now • Urgent Call</span>
            </AlertBadge>

            <PromoTitle>
              {currentProperty.title} <span>{currentProperty.location}</span>
            </PromoTitle>

            <PromoDescription>
              {currentProperty.description}
            </PromoDescription>

            <HighlightFeatures>
              {currentProperty.features.map((feature, idx) => (
                <div key={idx}>
                  <CheckCircle2 size={14} /> {feature}
                </div>
              ))}
            </HighlightFeatures>

            <ActionButton href={currentProperty.link}>
              {currentProperty.buttonText} <ArrowRight size={16} />
            </ActionButton>
          </PromoCard>
        </Fade>

        {/* Slider Navigation Buttons and Indicators */}
        <NavButtonsContainer>
          <ControlButton onClick={handlePrev} aria-label="Previous Property">
            <ChevronLeft size={20} />
          </ControlButton>
          <ControlButton onClick={handleNext} aria-label="Next Property">
            <ChevronRight size={20} />
          </ControlButton>
        </NavButtonsContainer>

        <IndicatorsContainer>
          {propertiesData.map((_, index) => (
            <Dot
              key={index}
              $active={currentIndex === index}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </IndicatorsContainer>
      </Container>
    </PromoSection>
  );
};

export default PropertyCarouselBanner;